export const CART = 'CART';
export const CALENDAR = 'CALENDAR';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const CHANGE_QTY = 'CHANGE_QTY';
